/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import appLayoutStyle from 'assets/jss/layouts/appLayoutStyle.jsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import UnauthorizedAccess, { reasons } from './UnauthorizedAccess';

const intersectArrays = (arr1, arr2) => (arr1 || []).filter((role) => (arr2 || []).includes(role));

/**
 * This component wraps a react-router Route, and protects it by checking if the user the right keycloak role to access the component/page
 */

class ProtectedRoute extends Component {
  render() {
    let isAuthorized = false;
    let hasValidLicense = false;
    let returnCode = reasons.isNotAllowed;
    const { userRoles, userLicense, requiredRoles } = this.props;

    if (!requiredRoles || !requiredRoles.length) {
      isAuthorized = true;
    } else {
      isAuthorized = intersectArrays(userRoles, requiredRoles).length > 0;
      if (!isAuthorized) returnCode = reasons.isNotAllowed;
    }

    if (userLicense) {
      // expirationDate est stocké en String au format Date.toString() (accounts-front
      // ManageLicenses stocke `moment()....toString()`), NI ISO NI RFC2822 → `moment(String)`
      // émet un warning de dépréciation à chaque route protégée (T5, aussi en prod). On passe
      // par `new Date()` (comme le serveur : accesscontrol.js `Date.parse`) → même instant, 0 warning.
      if (moment().isAfter(moment(new Date(userLicense.expirationDate)))) {
        returnCode = reasons.licenceExpired;
      } else {
        hasValidLicense = true;
      }
    } else {
      returnCode = reasons.noLicence;
    }

    if (isAuthorized && hasValidLicense) {
      return (
        <Route
          path={this.props.path}
          render={(props) => (
            <this.props.component
              {...props}
              userRoles={this.props.userRoles}
              userLicense={this.props.userLicense}
              userTypes={this.props.userTypes}
            />
          )}
          key={this.props.sidebarName}
        />
      );
    }

    return <UnauthorizedAccess reason={returnCode} />;
  }
}

ProtectedRoute.propTypes = {
  userRoles: PropTypes.array.isRequired,
  userTypes: PropTypes.array.isRequired,
  userLicense: PropTypes.object.isRequired,
  requiredRoles: PropTypes.array.isRequired,
  path: PropTypes.string.isRequired,
  sidebarName: PropTypes.string,
};

ProtectedRoute.defaultProps = {
  sidebarName: '',
};

export default withStyles(appLayoutStyle)(ProtectedRoute);
